module.exports = __webpack_public_path__ + "img/centrifuge-A-light.2a74bc5e.png";